import useMerchantWebPortalAxios from "../../utils/axiosWeb";
import { useDispatch } from "react-redux";
import { settingBillsData, settingBillsObjectData } from "../../features/billsPageSlice";
import useResponse from "../../app/useResponse";

function useTerranetApi() {
  const dispatch = useDispatch();
  const MerchantWebPortalAxios = useMerchantWebPortalAxios();
  const { successResponse, errorResponse } = useResponse();
  const errorRes = {
    response: {
      data: {
        isPopup: true,
        PopupTitle: "Error",
        PopupDescription: "Something went wrong. Please try again later.",
      },
    },
  };
  const TerranetBill = async (mobileNumber) => {
    try {
      dispatch(settingBillsData({ field: "isloading", value: "loading" }));
      const res = await MerchantWebPortalAxios.post(`/api/terranet/get_accounts`, {
        username: mobileNumber,
      });
      dispatch(settingBillsData({ field: "isloading", value: "idle" }));

      if (res?.data?.status) {
        if (res?.data?.data?.flag !== 1) {
          // toast.warning(res?.data?.message);
          successResponse(res?.data?.data?.Popup);
        } else {
          dispatch(settingBillsObjectData({ mainField: "terranet", field: "accountNb", value: mobileNumber }));
          dispatch(settingBillsObjectData({ mainField: "terranet", field: "productList", value: res?.data?.data?.return }));
          dispatch(settingBillsData({ field: "currentPage", value: "listProduct" }));
        }
        return res?.data;
      }
    } catch (error) {
      dispatch(settingBillsData({ field: "isloading", value: "idle" }));
      errorResponse(errorRes);
    }
  };

  const PayTerranetBill = async (payload) => {
    try {
      dispatch(settingBillsData({ field: "isloading", value: "loading" }));
      const res = await MerchantWebPortalAxios.post(`/api/terranet/refill_customer_terranet`, payload);
      dispatch(settingBillsData({ field: "isloading", value: "idle" }));
      if (res.data.status && res.data.data !== -1 && res.data?.data?.flagCode !== -1) {
        return res.data;
      } else {
        // toast.warning(res.data.message);
      }
    } catch (error) {
      dispatch(settingBillsData({ field: "isloading", value: "idle" }));
      errorResponse(errorRes);
    }
  };

  return {
    TerranetBill,
    PayTerranetBill,
  };
}

export default useTerranetApi;
